import React, { createContext, useContext, ReactNode } from 'react';
import { useSidebarCounts } from 'hooks/useSidebarCounts';

interface SidebarCountsContextType {
  counts: {
    feedbackCount: number;
    technicalNotesCount: number;
  };
  loading: boolean;
  refetch: () => Promise<void>;
  refetchFeedbackCount: () => Promise<void>;
  refetchTechnicalNotesCount: () => Promise<void>;
}

const SidebarCountsContext = createContext<SidebarCountsContextType | undefined>(undefined);

export const SidebarCountsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const sidebarCounts = useSidebarCounts();

  return (
    <SidebarCountsContext.Provider value={sidebarCounts}>
      {children}
    </SidebarCountsContext.Provider>
  );
};

export const useSidebarCountsContext = () => {
  const context = useContext(SidebarCountsContext);
  if (context === undefined) {
    throw new Error('useSidebarCountsContext must be used within a SidebarCountsProvider');
  }
  return context;
};

